module.exports = __webpack_public_path__ + "img/facebook.b6e0e01e.svg";